import React, { useState, useEffect } from "react";
import axios from "axios";
import { Routes, Route, Link, useLocation } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import AgentForm from "./pages/AgentForm";
import AllForms from "./pages/AllForms";
import VerifyForm from "./pages/VerifyForm";
import Logs from "./pages/Logs";
import UserCreate from "./pages/UserCreate";
import Reports from "./pages/Reports";
import QA from "./pages/QA";
import Campaign from "./pages/Campaign";
import LeadSource from "./pages/LeadSource";
import Product from "./pages/Product";
import ProductRules from "./pages/ProductRules";
import Disposition from "./pages/Disposition";
import SourceCode from "./pages/SourceCode";
import SourceMapping from "./pages/sourceMapping";
import CampaignCenterMapping from "./pages/CampaignCenterMapping";
import ProductMapping from "./pages/ProductMapping";
import LoginDialog from "./components/LoginDialog";
import ResetPassword from "./pages/ResetPassword";
import UploadedBins from "./pages/UploadedBins";
import Center from "./pages/Center";
import EditPassword from "./pages/EditPassword";
import PageAccess from "./pages/PageAccess";
import CenterReportMapp from "./pages/CenterReportMapp";
import QAAssigned from "./pages/QAAssigned";
import AssessorTask from "./pages/AssessorTask";
import QAReport from "./pages/QAReport";
import LeadsourceCenterMapping  from "./pages/LeadsourceCenterMapping";
import Api  from "./pages/Api"
import Apisc  from "./pages/Apisc"
import Apibsndmy  from "./pages/Apibsndmy"
import Api43md from "./pages/Api43md";







function Restricted() {
  return (
    <div className="page">
      <h2>Access Denied</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}

function App() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [accessiblePages, setAccessiblePages] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  // Load user from localStorage
  useEffect(() => {
    const savedUser = localStorage.getItem("crmUser");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  // ✅ Fetch access based on ROLE only
  useEffect(() => {
    if (!user?.role) return;

    const fetchAccess = async () => {
      try {
        setLoadingAccess(true);
        const resAccess = await axios.get(
          "https://crm-server-htk6.vercel.app/api/page-access"
        );
        const accessData = resAccess.data || [];

        // 🔑 Match current user role with DB
        const match = accessData.find(
          (a) => a.name?.trim().toLowerCase() === user.role.trim().toLowerCase()
        );

        setAccessiblePages(match ? match.pages || [] : []);
      } catch (err) {
        console.error("❌ Error fetching page access:", err);
        setAccessiblePages([]);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchAccess();
  }, [user]);

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser);
    localStorage.setItem("crmUser", JSON.stringify(loggedInUser));
  };

  const handleLogout = async () => {
    if (user) {
      try {
        await axios.put(`https://crm-server-htk6.vercel.app/api/users/${user._id}`, {
          loginStatus: false,
        });
      } catch (err) {
        console.error("❌ Error updating logout status:", err);
      }
    }
    setUser(null);
    localStorage.removeItem("crmUser");
  };

  // Disable right-click globally
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  const menuItems = [
    { path: "/", label: "Dashboard", component: <Dashboard currentUser={user} /> },
    
    { path: "/agent", label: "Agent Form", component: <AgentForm currentUser={user} /> },
    { path: "/all", label: "All Forms", component: <AllForms currentUser={user} /> },
    { path: "/verify", label: "Verify Form", component: <VerifyForm currentUser={user} /> },
     { path: "/QAAssigned", label: "QA Assigned", component: <QAAssigned /> },
      { path: "/AssessorTask", label: "AssessorTask", component: <AssessorTask currentUser={user} /> },
    { path: "/logs", label: "Logs", component: <Logs currentUser={user} /> },
    { path: "/user", label: "User Create", component: <UserCreate currentUser={user}/> },
    { path: "/password", label: "Reset Password", component: <ResetPassword currentUser={user} /> },
    { path: "/reports", label: "Reports", component: <Reports currentUser={user} /> },
       { path: "/QAReport", label: "QAReport", component: <QAReport currentUser={user} /> },
     { path: "/CenterReportMapp", label: "CenterReportMapping", component: <CenterReportMapp currentUser={user} /> },
    { path: "/qa", label: "QAA", component: <QA /> },
    { path: "/campaign", label: "Campaign", component: <Campaign /> },
    { path: "/leadsource", label: "Lead Source", component: <LeadSource /> },
    { path: "/product", label: "Product", component: <Product /> },
    { path: "/productRules", label: "Product Rules", component: <ProductRules /> },
    { path: "/disposition", label: "Disposition", component: <Disposition /> },
    { path: "/sourcecode", label: "Add Source Code", component: <SourceCode /> },
    { path: "/SourceMapping", label: "Leadsource Mapping", component: <SourceMapping /> },
    { path: "/campaign-mapping", label: "Campaign Center Mapping", component: <CampaignCenterMapping /> },
    { path: "/LeadsourceCenterMapping", label: "Leadsource Center Mapping", component: <LeadsourceCenterMapping /> },

    { path: "/productMappings", label: "Product Map", component: <ProductMapping /> },
    { path: "/uploadedbins", label: "Uploaded Bins", component: <UploadedBins /> },
    { path: "/Center", label: "Create Center", component: <Center /> },
    { path: "/PageAccess", label: "Page Access", component: <PageAccess currentUser={user} /> },
     { path: "/EditPassword", label: "Edit Password", component: <EditPassword currentUser={user} /> },
    { path: "/Api", label: "API-MD/ID", component: <Api currentUser={user} /> },
     { path: "/Apisc", label: "API-SC", component: <Apisc currentUser={user} /> },
      { path: "/Apibsndmy", label: "API-BSN_DMY", component: <Apibsndmy currentUser={user} /> },
      { path: "/Api43md", label: "API-43_MD", component: <Api43md currentUser={user} /> },
        
    
  ];

  if (!user) return <LoginDialog onLogin={handleLogin} />;
  if (loadingAccess) return <p>Loading access...</p>;

  return (
    <div className="crm-app">
      {/* Header */}
      <header className="crm-header">
        <h2 className="header-title">CRM APPLICATION</h2>
        <div className="user-profile">
          <div className="user-avatar">
            {user.firstName?.charAt(0)}
            {user.lastName?.charAt(0)}
          </div>
          <div className="user-details">
            <div className="user-name">
              {user.firstName} {user.lastName}
            </div>
            <div className="user-meta">
              <span>🆔 {user.empCode}</span>
              <span>🛡️ {user.role}</span>
              <span>🏢 {user.center}</span>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </header>

      <div className="crm-body">
        {/* Sidebar */}
        <aside className="sidebar">
          <h2 className="sidebar-title">Menu</h2>
          <nav className="sidebar-menu">
            {menuItems.map((item) =>
              accessiblePages.includes(item.label) ? (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`sidebar-item ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                >
                  {item.label}
                </Link>
              ) : null
            )}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="main-content">
          <Routes>
            {menuItems.map((item) => {
              const element = accessiblePages.includes(item.label)
                ? item.component
                : <Restricted />;
              return <Route key={item.path} path={item.path} element={element} />;
            })}
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
